import { useIntl } from "@services/i18n";
import PublicHomeView from "@views/PublicHomeView.vue";
import ChargerSetupView from "@/components/views/ChargerSetupView.vue";
import { configureRouter } from "@/.shared/services/routing-services";
import ChargerResultsListView from "@/components/views/ChargerResultsListView.vue";
import ChargerResultsMapView from "@/components/views/ChargerResultsMapView.vue";
import { useAuthentication } from "@/.shared/services/auth";
import {
  hideUIError,
  isUIErrorOpen,
} from "@/.shared/services/errorHandling/error-ui";


export function configureAppRoutes() {
  configureRouter((router) => {
    router.addRoute("home", (b) =>
      b
        .withPath("")
        .withComponent(PublicHomeView)
        .allowAnonymous()
       
    );

    router.addRoute("charge-session-setup", (b) =>
      b
        .withPath("charge-session-setup")
        .withComponent(ChargerSetupView)
        .allowAnonymous()
    );

    router.addRoute("charger-results", (b) =>
      b
        .withPath("charger-results")
        .withComponent(ChargerResultsListView)
        .allowAnonymous()
    );

    router.addRoute("charger-results-map", (b) =>
      b
        .withPath("charger-results-map")
        .withComponent(ChargerResultsMapView)
        .allowAnonymous()
    );

    let navigationInfo: { direction: string } | null;
    router.options.history.listen((_to, _from, info) => {
      navigationInfo = info;
    });

    router.beforeEach(() => {
      if (
        navigationInfo != null &&
        navigationInfo.direction == "back" &&
        isUIErrorOpen()
      ) {
        hideUIError();
        return false;
      }
      return true;
    });

    router.beforeEach((to, _from, next) => {
      const intl = useIntl();
      let title = intl.i18n.t("app_name");
      if (to.meta.titleKey != null)
        title = `${title} - ${intl.i18n.t(to.meta.titleKey as string)}`;
      document.title = title;
      next();
    });
  });
}
